import { $pay } from "@/utils/api";

export function getCartGoods(params) {
    return $pay().get("/mall/goods/cart", {
        params,
    });
}
// 添加购物车是固定的增量，只提交新加购的数量
export function addCartGoods(data) {
    return $pay().post(`/mall/goods/cart`, data);
}
// 更新购物车 是在购物车清单界面，比如用户调整为5，则传递5
export function updateCartGoods(data) {
    return $pay().put(`/mall/goods/cart`, data);
}
// 删除商品，对应每一条后面的垃圾桶。同时，如果当数量为1的时候，继续点击减号，则提示用户是否移除？确定则也移除。
export function deleteCartGoods(params) {
    return $pay().delete(`/mall/goods/cart`, { params });
}
